import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CloudIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M18.24 9h-.576a8.89 8.89 0 00-3.84-4.8C11.904 3 9.6 2.7 7.392 3.3 2.784 4.7 0 9.5 1.152 14.2c.96 4 4.416 6.8 8.448 6.8h8.64c3.264 0 5.76-2.6 5.76-6s-2.496-6-5.76-6zm0 10H9.6c-3.072 0-5.76-2.2-6.528-5.2-.864-3.7 1.248-7.4 4.896-8.5A5.24 5.24 0 019.696 5c1.152 0 2.208.3 3.264.9 1.536.9 2.688 2.5 3.168 4.3.096.4.48.8.96.8h1.152c2.112 0 3.84 1.8 3.84 4s-1.728 4-3.84 4z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
CloudIcon.isCarinaIcon = true;
export default CloudIcon;
